import React from 'react';
import './skeleton-base.css';

const SkeletonVideoCard = () => (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4 skeleton-card">
        <div className="card explore-box card-animate">
            <div className="skeleton-element" style={{
                height: "200px",
                borderRadius: "8px 8px 0 0"
            }}>
                <div className="skeleton-shimmer"></div>
                {/* Play button placeholder */}
                <div style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "50px",
                    height: "50px",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <i className="ri-play-fill" style={{ color: "rgba(255,255,255,0.3)", fontSize: "24px" }}></i>
                </div>
            </div>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="skeleton-element skeleton-title skeleton-delay-1">
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-element skeleton-icon skeleton-delay-2">
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
                <div className="skeleton-element skeleton-text skeleton-mb-2 skeleton-delay-3">
                    <div className="skeleton-shimmer"></div>
                </div>
                <div className="skeleton-element skeleton-small-text skeleton-delay-4">
                    <div className="skeleton-shimmer"></div>
                </div>
            </div>
        </div>
    </div>
);

export default SkeletonVideoCard;